import { useMutation } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { UserProductTypes } from '@/types';

export const reactivateUserCancelledProduct = ({
  mdirectorId,
}: {
  mdirectorId: string;
}): Promise<UserProductTypes[]> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'my-products/' + mdirectorId;
  return axios
    .patch(endPoint, {
      validateStatus: (status: number) => status < 500,
    })
    .then((response: any) => {
      return response.data;
    });
};

type UseReactivateUserCancelledProductOptions = {
  config?: MutationConfig<typeof reactivateUserCancelledProduct>;
};

export const useReactivateUserCancelledProduct = ({
  config,
}: UseReactivateUserCancelledProductOptions = {}) => {
  return useMutation({
    onMutate: async (creatingNotification: any) => {
      await queryClient.cancelQueries(['my-products', creatingNotification]);

      const previousDetails = queryClient.getQueryData<UserProductTypes>([
        'my-products',
        creatingNotification,
      ]);

      queryClient.setQueryData(['my-products', creatingNotification], {
        ...previousDetails,
        ...creatingNotification.data,
      });

      return { previousDetails: previousDetails };
    },
    onError: (_, __, context: any) => {
      if (context?.previousDetails) {
        queryClient.setQueryData(['my-products', context.previousDetails], context.previousDetails);
      }
    },
    onSuccess: (data) => {
      return queryClient.refetchQueries(['my-products', data]);
    },
    ...config,
    mutationFn: reactivateUserCancelledProduct,
  });
};
